import * as React from "react";

export default class Textstring extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { model } = this.props;

        //console.debug("Textstring model", model);
        if (!model.value) return (null); // Early out..

        let markup = model.editor.config.markup;
        markup = markup.replace("#value#", model.value);

        if (model.editor.config.style) {
            markup = markup.replace("#style#", model.editor.config.style);
        }
        //		const url = model.value.image;
        //return (<div>RENDER:media</div>)
        return (<div dangerouslySetInnerHTML={{ __html: markup }} />);
    }

}